/**
 * Admin Referees Contracts - Database-First Zod Schemas
 *
 * SOURCE OF TRUTH: PostgreSQL referees table
 * Generated from MCP queries on 2026-01-08
 *
 * Related DB objects:
 * - Table: referees
 *
 * Table schema (referees):
 * - identifier: varchar PK
 * - referral_code: varchar
 * - name: varchar
 * - commission_percent: numeric(5,2)
 * - total_earned: numeric(10,2)
 * - total_lost: numeric(10,2)
 * - total_withdrawn: numeric(10,2)
 * - total_converted: numeric(10,2)
 * - net: numeric(10,2)
 * - balance: numeric(10,2)
 * - created_at: timestamptz
 * - updated_at: timestamptz
 */
import { z } from 'zod';
// =============================================================================
// API RESPONSE SCHEMAS
// =============================================================================
/**
 * Single referee item in admin list
 * GET /api/admin/referees response array item
 */
export const refereeListItemSchema = z.object({
    identifier: z.string(),
    referralCode: z.string(),
    name: z.string(),
    commissionPercent: z.number(),
    totalEarned: z.number(),
    totalLost: z.number(),
    totalWithdrawn: z.number(),
    totalConverted: z.number(),
    net: z.number(),
    balance: z.number(),
    createdAt: z.string(), // ISO string
    updatedAt: z.string(), // ISO string
});
/**
 * GET /api/admin/referees response data
 * Array of referee items
 */
export const refereesListResponseSchema = z.array(refereeListItemSchema);
//# sourceMappingURL=referees.js.map